import { t } from "../services/utils";
export default {
  ONE_TIME: 1,
  SUBSCRIPTION: 2
};